import React from "react";
import {injectIntl} from "react-intl";
const RegularText = ({text, values = {}, intl, className, children, dataCy = null}) => (
    <p className={className} data-cy={dataCy}>{text ? intl.formatMessage({id: text}, values) : children}</p>
);
export default injectIntl(RegularText);